import React, { Component } from "react";
import Link from "gatsby-link";
import ChevronSmallDown from "../../svgs/ChevronSmallDown";
import "./styles.scss";

class EducationMenu extends Component {
    constructor() {
        super();

        this.state = {
            showMenu: false
        };

        this.showMenu = this.showMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
    }

    showMenu(event) {
        event.preventDefault();

        this.setState({ showMenu: true }, () => {
            document.addEventListener(`click`, this.closeMenu);
        });
    }

    closeMenu(event) {
        if (!this.dropdownMenu.contains(event.target)) {
            this.setState({ showMenu: false }, () => {
                document.removeEventListener(`click`, this.closeMenu);
            });
        }
    }

    render() {
        return (
            <li className="site-header__nav-item">
                <button
                    onClick={this.showMenu}
                    className="education-menu__button"
                >
                    Blog{` `}
                    <div className="education-menu__button-icon">
                        <ChevronSmallDown />
                    </div>
                </button>

                {this.state.showMenu ? (
                    <div
                        className="site-header__nav-item education-menu__nav-item"
                        ref={element => {
                            this.dropdownMenu = element;
                        }}
                    >
                        <div className="education-menu">
                            <div className="inner education-menu__inner">
                                <Link
                                    to="learn/articles/"
                                    title="Articles"
                                    className="education-menu__item education-menu__item--articles"
                                >
                                    <img
                                        src="../../../../images/nav/articles.jpg"
                                        alt="Articles"
                                    />
                                    <div className="education-menu__item-text">
                                        Articles
                                    </div>
                                </Link>
                                <Link
                                    to="learn/infographics/"
                                    title="Infographics"
                                    className="education-menu__item education-menu__item--infographics"
                                >
                                    <img
                                        src="../../../../images/nav/infographics.jpg"
                                        alt="Infographics"
                                    />
                                    <div className="education-menu__item-text">
                                        Infographics
                                    </div>
                                </Link>
                                <Link
                                    to="learn/guides/"
                                    title="Guides"
                                    className="education-menu__item education-menu__item--Guides"
                                >
                                    <img
                                        src="../../../../images/nav/guides.jpg"
                                        alt="Guides"
                                    />
                                    <div className="education-menu__item-text">
                                        Guides
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                ) : null}
            </li>
        );
    }
}

export default EducationMenu;
